

















































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateUser from './create-user.vue'
import EditUser from './edit-user.vue'

class PageUserRequest extends PageRequest {
  phoneNumber:string;
}

@Component({
  components: {CreateUser, EditUser}
})
export default class Users extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  seletedList:any=[];

  get list() {
    return this.$store.state.user.list;
  };

  get loading() {
    return this.$store.state.user.loading;
  }

  create() {
    this.createModalShow = true;
  }

 async handleSelectAll(selection) {
   let selectionList :any= []
    for (let i = 0; i < selection.length; i++) {
      selectionList.push(selection[i].id);
    }
    this.seletedList=selectionList;
  }

  pageChange(page: number) {
    this.$store.commit('user/setCurrentPage', page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit('user/setPageSize', pagesize);
    this.getpage();
  }

  search() {
    this.$store.commit('user/setCurrentPage', 1);
    this.getpage();
  }


  async getpage() {

    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: 'user/getCashBackUserList',
      data: this.pagerequest
    })
  }

  get pageSize() {
    return this.$store.state.user.pageSize;
  }

  get totalCount() {
    return this.$store.state.user.totalCount;
  }

  get currentPage() {
    return this.$store.state.user.currentPage;
  }

  columns = [{
    title: '选择',
    type: 'selection',
    width: 50,
  }, {
    title: this.L('UserName'),
    tooltip: true,
    width: 150,
    key: 'userName',
  }, {
    title: this.L('Name'),
    tooltip: true,
    width: 150,
    key: 'name'
  },
    {
      title: '手机号',
      tooltip: true,
      key: 'phoneNumber'
    }, {
      title: this.L('IsActive'),
      width: 80,
      render: (h: any, params: any) => {
        return h('span', params.row.isActive ? this.L('Yes') : this.L('No'))
      }
    }, {
      title: "账户余额",
      key: 'amount',
      width: 100,
      render: (h: any, params: any) => {
        return h('span', this.L('CurrencyIcon') + params.row.amount.toFixed(2))
      }
    }, {
      title: this.L('CreationTime'),
      key: 'creationTime',
      width: 150,
      render: (h: any, params: any) => {
        return h('span', params.row.creationTime ? new Date(params.row.creationTime).toLocaleString() : '暂无')
      }
    }, {
      title: '最后操作时间',
      width: 150,
      render: (h: any, params: any) => {
        return h('span', params.row.lastModificationTime ? new Date(params.row.lastModificationTime).toLocaleString() : '暂无')
      }
    }, {
      title: this.L('Actions'),
      key: 'Actions',
      width: 120,
      render: (h: any, params: any) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginLeft: '5px',
            },
            on: {
              click:async () => {
                this.$Modal.confirm({
                  title:this.L('Tips'),
                  content:'确定发送短信通知吗',
                  okText:this.L('Yes'),
                  cancelText:this.L('No'),
                  onOk:async()=>{
                    let  query:any = [];
                    query.push(params.row.id);
                    await this.sendNotice(query)
                  }
                })

              }
            }
          }, '发送'),
        ])
      }
    }]

  async  handCancelAll(){
    this.seletedList=[];
  }
  async sendNotice(ids:number[]){
    if(ids.length>0){
      const params={
        ids
      }
      await this.$store.dispatch({
        type: 'user/SendAmoutSmsToUser',
        data: params
      }).then(res=>{
        if(res && res.data){
          console.log(res,'res')
          this.$Message.success({
            content:'发功成功'
          })
          this.getpage();
        }
      })
    }else{
      this.$Message.error({
        content:'选择不能为空'
      })
    }
  }
  async created() {
    this.getpage();
    await this.$store.dispatch({
      type: 'user/getRoles'
    })
  }
}
